import React from 'react';
import {NavBarContainer, NavUl, NavLi, NavLiJourney} from '../styles/navigation_bar_styles';
import ProgressBar from '../containers/progress_bar_container';

const Navigation = (props) => {

  return(
    <NavBarContainer>
      <NavUl>
        <NavLi onClick={props.onClick} name="hotels" selection={props.data.nav_selection}> Hotels </NavLi>
        <NavLi onClick={props.onClick} name="attractions" selection={props.data.nav_selection}> Attractions </NavLi>
        <NavLi onClick={props.onClick} name="restaurants" selection={props.data.nav_selection}> Restaurants </NavLi>
        <NavLiJourney onClick={props.onClick} name="whole_journey" selection={props.data.nav_selection}> View Your Journey </NavLiJourney>
      </NavUl>
      <ProgressBar data={props.data} nav_selection={props.data.nav_selection} seeWholeJourney={props.seeWholeJourney} />
    </NavBarContainer>

  )

}

export default Navigation;
